import React from 'react';
import './RampIcon.css';
import './Ramp1Frames.css';
import './Ramp2Frames.css';
import './Ramp3Frames.css';

export default class RampIcon extends React.Component {

    state = {
        currentFrame: 1,
        totalFrames: 1,
        currentInterval: null
    }

    NUM_FRAMES = 49;
    FRAMERATE = 16;

    stopAnimation =() => {
        const { currentInterval } = this.state;

        if(currentInterval) {
            clearInterval(currentInterval);
        }

        this.setState({currentInterval: null, currentFrame: 1, totalFrames: 1});
        this.props.onAnimationEnd();
    }

    animateRamp = () => {
        const { totalFrames } = this.state;
        //console.log("Current frame:", currentFrame, "Total frames:", totalFrames);
        let direction = 1;
        if(totalFrames >= this.NUM_FRAMES) {
            direction = -1;
        }

        if(totalFrames >= ((this.NUM_FRAMES*2) -1)) {
            this.stopAnimation();
        } else {
            this.setState((state) => ({currentFrame: state.currentFrame + direction, totalFrames: state.totalFrames + 1}));
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if(nextProps && nextProps.animate){
            const interval = setInterval(this.animateRamp, this.FRAMERATE);
            this.setState({currentInterval: interval});
        }
    }

    render() {
        const {currentFrame } = this.state;
        const { ramp, visible } = this.props;
        const defaultClassName = 'overlay overlay__keyframe--' + ramp + '-frame1' + (!visible ? '--hidden' : '');
        const currentClassName = 'overlay overlay__keyframe--' + ramp + '-frame' + currentFrame  + (!visible ? '--hidden' : '');

        return (
            <React.Fragment>
                <div className={this.props.animate ? currentClassName : defaultClassName}></div>
            </React.Fragment>
        );
    } 
}